import { render, staticRenderFns } from "./detailAutomation.vue?vue&type=template&id=063e8d42"
import script from "./detailAutomation.vue?vue&type=script&lang=js"
export * from "./detailAutomation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports